/**
 * Sorts collection grids: purchasable → quote → sold out.
 */
window.theme = window.theme || {};

const isCollectionQuoteProduct = (item) => {
  const quickAdd = item.querySelector('.card__quick-add');
  if (!quickAdd) return false;

  const quoteLink = quickAdd.querySelector('a.btn');
  if (!quoteLink) return false;

  const label = quoteLink.textContent.trim().toLowerCase();
  return label.includes('request a quote') || label.includes('available to order');
};

const isCollectionProductSoldOut = (item) => {
  if (!item?.querySelector?.('product-card')) return false;
  if (isCollectionQuoteProduct(item)) return false;

  const tier = Number(item.dataset.collectionSortTier);
  if (tier === 2) return false;
  if (tier === 3 || item.dataset.collectionSoldOut === 'true') return true;

  if (item.querySelector('.product-label--sold-out')) return true;

  const quickAddText = item.querySelector('.quick-add-btn-text');
  if (quickAddText) {
    const label = quickAddText.textContent.trim().toLowerCase();
    if (label.includes('sold out') || label.includes('no stock')) return true;
  }

  const addBtn = item.querySelector('[name="add"]');
  if (addBtn?.disabled) {
    const label = addBtn.textContent.trim().toLowerCase();
    if (label.includes('sold out') || label.includes('no stock')) return true;
  }

  return false;
};

const getCollectionSortTier = (item) => {
  const tier = Number(item.dataset.collectionSortTier);
  if (tier === 2 || tier === 3) return tier;
  if (isCollectionQuoteProduct(item)) return 2;
  if (isCollectionProductSoldOut(item)) return 3;
  return 1;
};

theme.sortCollectionProductsSoldOutLast = (root = document) => {
  const scope = root?.querySelector ? root : document;
  const lists = scope.querySelectorAll(
    '.main-products-grid__results > ul[role="list"], .featured-collection-products ul[role="list"]'
  );

  lists.forEach((list) => {
    const items = [...list.children];
    const tier1 = [];
    const tier2 = [];
    const tier3 = [];

    items.forEach((item) => {
      if (!item.matches('.js-pagination-result') || !item.querySelector('product-card')) {
        tier1.push(item);
        return;
      }

      const tier = getCollectionSortTier(item);

      if (tier === 3) {
        item.dataset.collectionSortTier = '3';
        item.dataset.collectionSoldOut = 'true';
        tier3.push(item);
      } else if (tier === 2) {
        item.dataset.collectionSortTier = '2';
        delete item.dataset.collectionSoldOut;
        tier2.push(item);
      } else {
        item.dataset.collectionSortTier = '1';
        delete item.dataset.collectionSoldOut;
        tier1.push(item);
      }
    });

    [...tier1, ...tier2, ...tier3].forEach((item) => {
      list.appendChild(item);
    });
  });
};

const runCollectionProductSort = () => {
  if (!theme.sortCollectionProductsSoldOutLast) return;
  theme.sortCollectionProductsSoldOutLast();
};

document.addEventListener('DOMContentLoaded', () => {
  runCollectionProductSort();
  requestAnimationFrame(runCollectionProductSort);
  setTimeout(runCollectionProductSort, 100);
  setTimeout(runCollectionProductSort, 500);
});

document.addEventListener('on:collection:products-sorted', (evt) => {
  theme.sortCollectionProductsSoldOutLast(evt.detail?.root || document);
});
